import { forwardRef, ForwardRefRenderFunction } from 'react'
import ReactEChartsCore from 'echarts-for-react'
import * as echarts from 'echarts/core'

import tailwind from 'styles/themeTokens'

import { EchartProps } from './types'

import './styles.scss'

const EchartCore: ForwardRefRenderFunction<ReactEChartsCore, EchartProps> = (
  props,
  ref
) => {
  // * object doesn't match eCharts theme shape. seems to merge options
  // use this for global styles that all charts should use
  // string is the name of a theme, so our own or a 3rd party
  const mergedTheme =
    typeof props.theme === 'string'
      ? props.theme
      : {
          textStyle: {
            fontFamily: tailwind.theme.fontFamily.base[0],
            color: tailwind.theme.colors.black
          },
          tooltip: {
            className: 'echarts-tooltip-boldness-override'
          },
          ...props.theme
        }

  return (
    <ReactEChartsCore
      ref={ref}
      className='w-full'
      echarts={echarts}
      theme={mergedTheme}
      style={{ height: '100%', ...props.style }}
      loadingOption={{ text: 'Loading', ...props.loadingOption }}
      {...props}
    />
  )
}

export const Echart = forwardRef(EchartCore)

export default Echart
